<template>
<div>

  <div v-for="(data, index) in foundData.displayIds" @click="select($event, data)"  v-bind ='[{id:data.id}]' :class="{'page_list_row-selected': data.add_info.selected}"   class="page_list_row clearfloat selectable"   >

<div @click="fullInf()" class="page_photo"><img     v-bind ='{src:data.photo_100}'    />   </div>
<div class="page_info selectable">
<div class="labeled_name">
<a  v-bind ='{href: "http://vk.com/id"+data.id}'   target="_blank"   style="text-decoration:none; color:#42648b;">
<div :class='{online:data.online}'>
<span > {{data.first_name.substring(35,-1).toLowerCase()}} </span>
<span > {{data.last_name.substring(35,-1).toLowerCase()}} </span>
</div>
</a>
<div v-if="data.source_info">
<v-tooltip top max-width="250" v-if="data.source_info.is_bot > 0 && data.source_info.is_bot != '10000'">
<div slot="activator">
<v-icon small color="red">mdi-robot</v-icon>
<span v-if="$store.state.filtersList[data.source_info.is_bot].name" style="color:red;font-size:.8em;letter-spacing: 2px;font-family:semi-expanded"> {{$store.state.filtersList[data.source_info.is_bot].name.slice(0,15) }} </span>
<v-tooltip v-if="$store.state.filtersList[data.source_info.is_bot].name.length>15" max-width="250" right>
<span slot="activator">...</span>
<span v-if="$store.state.filtersList[data.source_info.is_bot].name">{{$store.state.filtersList[data.source_info.is_bot].name}}</span>
</v-tooltip>
</div>
<span>Предположительно не целевая страница.</span>
</v-tooltip>
<v-tooltip top max-width="250" v-if="data.source_info.is_bot == '10000'">
<div slot="activator">
<v-icon small color="red">mdi-robot</v-icon>
<span style="color:red;font-size:.8em;letter-spacing: 2px;font-family:semi-expanded"> Бот фильтр vk </span>
</div>
<span>Предположительно не целевая страница.</span>
</v-tooltip>
</div>
</div>
<div  v-if="typeof data.city  !== 'undefined'"  class="labeled selectable" >  <span>{{data.city.title}}</span> </div>
<div v-if="typeof data.bdate !== 'undefined' && data.bdate.length> 7"  class="labeled selectable" >  <span>{{data.bdate}}</span> </div>
</div>

<div class="functions" style="width:180px;height:90px;float:right;margin-right:5px">

<div>
<v-tooltip v-if="data.can_write_private_message"   bottom   open-delay="2000" max-width="200"  >
<v-icon slot="activator" style="margin-right:3px" color="#273C51">mdi-email</v-icon>
<span>У пользователя открыты личные сообщения</span>
</v-tooltip>


<v-tooltip v-else   bottom   open-delay="2000" max-width="200"  >
<v-icon  slot="activator" style="margin-right:3px" color="gray">mdi-email-lock</v-icon>
<span>Позьзователь закрыл личные сообщения</span>
</v-tooltip>






<v-tooltip v-if="data.can_send_friend_request"   bottom   open-delay="2000" max-width="200"  >
<v-icon slot="activator" style="margin-right:3px" color="#273C51">mdi-account-plus</v-icon>
<span>Данного пользователя можно добавить в друзья</span>
</v-tooltip>

<v-tooltip v-if="!data.can_send_friend_request"   bottom   open-delay="2000" max-width="200"  >
<v-icon slot="activator" style="margin-right:3px"  >mdi-account-remove</v-icon>
<span>Пользователь не принимает заявки в друзья</span>
</v-tooltip>



<v-tooltip bottom   open-delay="2000" max-width="200"  :disabled="data.add_info.added" >
<v-icon slot="activator" style="margin-right:3px" color="#273C51">mdi-information</v-icon>
<span>Кликните что бы посмотреть более подробную информацию</span>
</v-tooltip>


<v-tooltip v-if="!data.add_info.added && !data.add_info.adding && !data.is_closed"  bottom   open-delay="2000" max-width="200"  :disabled="data.add_info.added" >
<v-icon slot="activator"  style="margin-right:3px" @click="addPage(data.id, data)" color="#273C51">mdi-plus</v-icon>
<span>Кликните что бы добавить данную страницу. После того как страница будет добавлена Вы сможете остлеживать новых подписчиков в разделе АКТИВНОСТЬ</span>
</v-tooltip>

<v-tooltip v-if="data.is_closed"   bottom   open-delay="2000" max-width="200" >
<v-icon slot="activator" style="margin-right:3px" color="gray" @click="" >mdi-plus</v-icon>
<span>Нет возможности отслежить активность закрытого профиля</span>
</v-tooltip>

<v-tooltip v-if="data.add_info.added && !data.is_closed "   bottom   open-delay="2000" max-width="200"  :disabled="!data.add_info.added" >
<v-icon slot="activator" style="margin-right:3px" color="green" @click="" >mdi-check</v-icon>
<span>Данная страница добавлена в список активность. Кликните что бы удалить из раздела АКТИВНОСТЬ</span>
</v-tooltip>

<div v-if="data.source_info" style="margin-top:-15px; ">
<v-divider v-if="data.source_info" style="margin-bottom:3px"> </v-divider>
<!-- Информация о источнике -->

<!-- Случай когда это подписчик сообщества -->
<div  v-if="data.source_info.source_type == 'group'">
<v-layout style="overflow:hidden">
<div><v-avatar size="32"><img :src="data.source_info.source_img"></v-avatar></div>
<div>
<a style="margin-left:3px;text-decoration:none" target="_blank" :href='"http://vk.com/public"+data.source_info.source_id'>
<span class="labeled_name">{{data.source_info.source_title.slice(0,12)}}</span>
<v-tooltip v-if="data.source_info.source_title.length > 12" top  max-width="200">
<span slot="activator">
...
</span>
<span>{{data.source_info.source_title}}</span>
</v-tooltip>
</a>
<div style="margin-left:3px;margin-top:-6px;color:gray;font-size:.85em">
{{new Date(data.source_info.add_time*1000).toLocaleString().slice(0,-3)}}
</div>
</div>
</v-layout>
</div>
<!-- Случай когда это подписчик человека -->
<div  v-if="data.source_info.source_type == 'page'">
<v-layout style="overflow:hidden">
<div><v-avatar size="32"><img :src="data.source_info.source_img"></v-avatar></div>
<div>
<a style="margin-left:3px;text-decoration:none" target="_blank" :href='"http://vk.com/id"+data.source_info.source_id'>
<span class="labeled_name">{{data.source_info.source_title.slice(0,12)}}</span>
<v-tooltip v-if="data.source_info.source_title.length > 12" top  max-width="200">
<span slot="activator">
...
</span>
<span>{{data.source_info.source_title}}</span>
</v-tooltip>
</a>
<div style="margin-left:3px;margin-top:-6px;color:gray;font-size:.85em">
{{new Date(data.source_info.add_time*1000).toLocaleString().slice(0,-3)}}
</div>
</div>
</v-layout>
</div>

<!-- Случай когда это лайк поста-->
<div  v-if="data.source_info.source_type == 'post_like'">
<v-layout style="overflow:hidden">
<div><v-avatar size="32"><v-icon medium color="red">mdi-heart</v-icon></v-avatar></div>
<div>
<a style="margin-left:3px;text-decoration:none" target="_blank" :href='"http://vk.com/wall"+data.source_info.source_id'>
<span class="labeled_name">wall{{data.source_info.source_id.slice(0,12)}}...</span>
<v-tooltip v-if="data.source_info.source_title.length > 12" top  max-width="200">
<span slot="activator">
...
</span>
<span>http://vk.com/wall{{data.source_info.source_id}}</span>
</v-tooltip>
</a>
<div style="margin-left:3px;margin-top:-6px;color:gray;font-size:.85em">
{{new Date(data.source_info.add_time*1000).toLocaleString().slice(0,-3)}}
</div>
</div>
</v-layout>
</div>

<!-- ЗАКРЫВАЕМ Информацию о источнике -->
</div>
</div>
</div>
</div>


<v-btn
v-if="loadMore" :loading="this.loadingMore"
block flat  color="#4A76A8" style="text-transform:none"
@click="offSetChanger(foundData,'pages')"
>
<v-icon left>mdi-eye</v-icon>
Просмотреть еще {{loadMore}}
</v-btn>

<v-snackbar v-model="sb.snackbar" :color="sb.color" absolute bottom :timeout="2000">
{{sb.text}}
<v-btn style="text-transform:none" dark flat @click="sb.snackbar = false">Ок</v-btn>
</v-snackbar>


</div>
</template>




<script>
import axios from 'axios'
export default {
props: ['foundData'],
data(){
return {
loadingMore:false,
adding: false,
sb:{
snackbar: false,
color: 'success',
text: ''
},
}
},

computed:{
loadMore(){
if(this.foundData.displayIds.length < 20){
this.offSetChanger(this.foundData,'pages')
return this.foundData.foundIds.length - this.foundData.displayIds.length
} else return this.foundData.foundIds.length - this.foundData.displayIds.length
},
},
methods:{

offSetChanger (data,type) {
if( typeof this.foundData.foundIds[0] == 'string'){
this.foundData.foundIds = this.foundData.foundIds.filter(item => item.length)
}

let pagesString =  data.foundIds.slice(data.offset, data.offset+20)
data.offset = data.offset * 1 + pagesString.length
if(pagesString.join(',') !== ''){
this.loadingMore = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_description.php', {
method: 'POST',
data: {
dataType: type,
dataString:  pagesString.join(','),
addInfo:{selected:data.selector}
}
})
.then( response => {
this.loadingMore = false
if(typeof response.data == 'object'){ data.displayIds =   data.displayIds.concat(response.data) }
console.log(data)
})
.catch(error => {
this.loadingMore = false
this.sb.snackbar = true
this.sb.color = 'red'
this.sb.text =  error
})
}
},

 addPage(add_list, data){

   data.add_info.adding =  true
   this.adding = true
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_add.php', {
        method: 'POST', data: {list: add_list}
      }).then(response => {
        data.add_info.adding =  false
        this.adding = false
       data.add_info.added =  true
           console.log(response.data)

      })
 },


  select(event,data){
    let classes = event.target.className.split(' ')
     if(classes.indexOf('selectable') !== -1){
         data.add_info.selected =  !data.add_info.selected
        if(data.add_info.selected){


          this.foundData.selectedIds.push(data.id.toString())
          console.log(this.foundData.selectedIds)
        } else  {


          this.foundData.selectedIds.splice(this.foundData.selectedIds.indexOf(data.id.toString()),1)
          console.log(this.foundData.selectedIds)
        }


     //    event.target.className = 'page_list_row-selected'
   }


 },

},

}
</script>

<style>
.clearfloat:after {
 content: "";
 display: table;
 clear: both;
}

.page_list_row_selected{
background-color : #EDF0F5;
border-radius : 7px
}



.page_list_row {

  margin: 15px;


  }

.page_list_row:hover {
  margin: 15px;
  border-radius:5px;
  cursor: pointer;
  }

.page_list_row .page_info  {

 padding-top: 10px;
 float: left;
   margin-bottom: 5px;
 margin-right: 25px;
   overflow: hidden;

   width: 250px;
 height: 80px;
}

.page_list_row .page_info .labeled_name{


    margin-bottom: 5px;
  color: #42648b;
    font-weight: 700;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;

}
.page_list_row .page_info .labeled_name:first-letter{
   text-transform: capitalize;
}




.page_list_row .glabeled {

   color: #656565;
}


.page_list_row .functions {
padding: 7px 0 0;
position: relative;
overflow: hidden;
width: 150px;
height: 80px;
}




.page_list_row .page_photo {


   float: left;
   margin: 3px;
   margin-right: 9px;
   position: relative;
   width: 80px;
   height: 80px;
   overflow: hidden;
}

.page_list_row .page_photo img {


   width: 80px;
   height: 80px;
   border-radius: 50%;
   -moz-force-broken-image-icon: 0;
   background-color: #fafbfc;
}
.online {
  color:green;
}
</style>
